module.exports = __webpack_public_path__ + "media/04.95ba7699.mp3";